import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from '@mui/material';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { storeContext } from '../../../../../context';

const StyledContainer = styled.div`
  a.link {
    > * {
      pointer-events: none;
    }
  }
`;
const RightRailLink = observer(({ cta, link, id, dataTestId }) => {
  const {
    translations: { currentLanguage }
  } = useContext(storeContext);
  return (
    <>
      <>
        <StyledContainer data-testid={`right-rail-${dataTestId}`}>
          <Trans
            i18nKey={cta}
            components={[
              <Link
                key={0}
                id={id}
                data-testid={dataTestId}
                href={link}
                rel="noopener noreferrer"
                target="_blank"
                color={'secondary'}
                component="a"
                variant={'body2'}
                className={'link'}
              >
                placeholder
              </Link>
            ]}
          />
        </StyledContainer>
      </>
    </>
  );
});

export default RightRailLink;
